import {connect} from 'react-redux';
import * as customers from 'customers/actions/customers';
import React, {Component} from 'react';
import {Button} from 'reactstrap';
import autobind from 'autobind-decorator';

@connect(
    state => {
        return {
            customers: state.customers
        }
    },
    dispatch => {
        return {
            toggleActive: () => dispatch(customers.toggleActive())
        }
    }
)
export default class ToggleActive extends Component {
    render() {
        return (
            <Button color='primary' className='pull-right' onClick={this.toggleActive}>
                {this.props.customers.showActive ? 'Aktive' : 'Inaktive'}
            </Button>
        )
    }

    @autobind
    toggleActive() {
        this.props.toggleActive()
    }
}